<p-toast />

@if (displayUrl) {
    <!-- Con foto: avatar circular -->
    <div
        class="foto-perfil-container"
        [class]="'size-' + size"
        [class.editable]="editable"
        (click)="triggerFileInput()"
        [pTooltip]="editable ? 'Cambiar foto de perfil' : ''"
        tooltipPosition="bottom"
    >
        <div class="foto-perfil-avatar">
            <img [src]="displayUrl" alt="Foto de perfil" class="foto-perfil-img" />

            @if (editable && !isUploading) {
                <div class="foto-perfil-overlay">
                    <i class="pi pi-camera"></i>
                </div>
            }

            @if (isUploading) {
                <div class="foto-perfil-loading">
                    <p-progressSpinner styleClass="w-6 h-6" strokeWidth="4" />
                </div>
            }
        </div>

        <input
            #fileInput
            type="file"
            accept="image/*"
            class="hidden"
            (change)="onFileSelected($event)"
        />
    </div>
} @else {
    <!-- Sin foto: botón invitación -->
    <div
        class="foto-perfil-empty"
        [class.editable]="editable"
        (click)="triggerFileInput()"
    >
            <div class="foto-perfil-empty-icon">
                <i class="pi pi-camera"></i>
            </div>
            <span class="foto-perfil-empty-title">Añadir foto de perfil</span>
            <span class="foto-perfil-empty-hint">Toca para subir una imagen</span>

        <input
            #fileInput
            type="file"
            accept="image/*"
            class="hidden"
            (change)="onFileSelected($event)"
        />
    </div>
}
